export default {
    "2010": {
        "commits": 402,
        "additions": 27242,
        "deletions": 11199,
        "numRepos": 17
    },
    "2011": {
        "commits": 1587,
        "additions": 108143,
        "deletions": 57259,
        "prs": 15,
        "numRepos": 22
    },
    "2012": {
        "commits": 591,
        "additions": 66124,
        "deletions": 27746,
        "prs": 136,
        "numRepos": 10
    },
    "2013": {
        "commits": 695,
        "additions": 82447,
        "deletions": 45779,
        "prs": 165,
        "numRepos": 21
    },
    "2014": {
        "commits": 400,
        "additions": 30049,
        "deletions": 17691,
        "prs": 115,
        "numRepos": 18
    },
    "2015": {
        "commits": 401,
        "additions": 32001,
        "deletions": 20329,
        "prs": 230,
        "numRepos": 19
    },
    "2016": {
        "commits": 601,
        "additions": 59487,
        "deletions": 45650,
        "prs": 181,
        "numRepos": 20
    },
    "2017": {
        "commits": 258,
        "additions": 39164,
        "deletions": 31381,
        "prs": 144,
        "numRepos": 12
    }
};



// WEBPACK FOOTER //
// ./src/data/code-stats.js